(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hk-work-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hk-work-gallery')) {
    customElements.define('hk-work-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.photos = Array.from(this.querySelectorAll('[data-photo]'));
        this.dialog = this.querySelector('dialog');
        this.index = 0;
        this.querySelector('[data-previous]').hidden = this.photos.length < 2;
        this.querySelector('[data-next]').hidden = this.photos.length < 2;
        this.addEventListener('click', (event) => {
          const photo = event.target.closest('[data-photo]');
          if (photo && this.dataset.editor !== 'true') {
            this.opener = photo;
            this.showPhoto(this.photos.indexOf(photo));
            this.dialog.showModal();
          }
          if (event.target.closest('[data-close]')) this.dialog.close();
          if (event.target.closest('[data-previous]')) this.showPhoto(this.index - 1);
          if (event.target.closest('[data-next]')) this.showPhoto(this.index + 1);
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
        }, options);
        this.dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showPhoto(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
          }
        }, options);
        this.dialog.addEventListener('close', () => this.opener?.focus(), options);
        if (this.dataset.protect === 'true' && this.dataset.editor !== 'true') {
          for (const name of ['contextmenu', 'dragstart']) {
            this.addEventListener(name, (event) => {
              if (event.target.closest('[data-photo], .hkw__viewer')) event.preventDefault();
            }, options);
          }
        }
      }
      showPhoto(index) {
        if (!this.photos.length) return;
        this.index = (index + this.photos.length) % this.photos.length;
        const photo = this.photos[this.index];
        const image = photo.querySelector('img').cloneNode(true);
        image.loading = 'eager';
        image.sizes = '90vw';
        image.draggable = false;
        this.querySelector('.hkw__viewer').replaceChildren(image);
        this.querySelector('.hkw__status').textContent = `${this.index + 1} / ${this.photos.length}`;
        this.querySelector('.hkw__caption').textContent = photo.closest('figure').querySelector('figcaption')?.textContent || '';
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
